export * from './linescape-enhances-sailing-schedules-with-actual-tracking-data';


// WEBPACK FOOTER //
// ./node_modules/angular-router-loader/src!./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./node_modules/tslint-loader!./src/app/press/linescape-enhances-sailing-schedules-with-actual-tracking-data/index.ts